


























import {Component, Vue} from "vue-property-decorator";
import PayrollDetailsReportView from "@/components/payroll/reports/payroll_details/PayrollDetailsReportView.vue";
import PaystubReportView from "@/components/payroll/reports/paystub/PaystubReportView.vue";
import GeneralPayrollReportView from "@/components/payroll/reports/general/GeneralPayrollReportView.vue";
import {Prop} from "vue-property-decorator/lib/decorators/Prop";
import {PayrollReport, ReportType} from "@/components/payroll/business/employments/employee/PayrollReport";
import BTPortalCollapse from "@/components/common/BTPortalCollapse.vue";
import {prettyEnum} from "@/utils/StringUtils";
import PaystubReport from "@/components/payroll/reports/paystub/PaystubReport.vue";
import PayrollDetailsReport from "@/components/payroll/reports/payroll_details/PayrollDetailsReport.vue";

@Component({
	methods: {
		prettyEnum(val: string) {
			return prettyEnum(val)
		}
	},
	components: {BTPortalCollapse}
})
export default class ReportView extends Vue {

	@Prop()
	private report!: PayrollReport

	@Prop()
	private callBack!: () => void;

	private view: typeof Vue | null = null;

	public created() {
		switch (this.report.reportType) {
			case ReportType.GENERAL:
				this.view = GeneralPayrollReportView;
				break;
			case ReportType.PAYROLL_DETAILS:
				this.view = PayrollDetailsReport;
				break;
			default:
				this.view = PaystubReport;
		}
	}

}

